import Axios from 'axios';

export const axiosInstance = Axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});